import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetSmartInstallmentInvoicesInput } from '../domain/dtos/get-smart-installment-invoices-input'
import { GetSmartInstallmentInvoicesOutput } from '../domain/dtos/get-smart-installment-invoices-output'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetSmartInstallmentInvoices {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: GetSmartInstallmentInvoicesInput): Promise<GetSmartInstallmentInvoicesOutput> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_WEB_URL}/smart-installments/${input.smartInstallmentId}/installments`,
      params: this.makeParams(input),
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data
    }

    throw new GeneralError()
  }

  private makeParams(input: GetSmartInstallmentInvoicesInput) {
    const body = {
      page: input.page,
      pageSize: input.pageSize,
      orderBy: 'scheduleEta',
      orderDirection: 'ASC',
    }

    return body
  }
}
